import {Component, TextComponent} from '@wonderlandengine/api';
import profile from './utils/profile.js';

/**
 * timer
 */

export class Timer extends Component {
    static TypeName = 'timer';

    getTimeString(time: number) {
        let seconds = Math.ceil(time / 1000);
        const minutes = Math.floor(seconds / 60);
        seconds = seconds % 60;

        return (
            (minutes < 10 ? '0' : '') + minutes + ':' + (seconds < 10 ? '0' : '') + seconds
        );
    }

    time = 0;
    timerEnd = 0;

    textComp: TextComponent | null = null;

    start() {
        this.textComp = this.object.getComponent(TextComponent);
    }

    update(dt: number) {
        if (!this.textComp) return;
        this.time += dt;
        if (this.time >= 1) {
            this.time -= 1;
            this.textComp.text =
                profile.getUsername() +
                '\n' +
                this.getTimeString(this.timerEnd - Date.now());
        }
    }
}
